import { Link } from "@tanstack/react-router";
import ViewDetailButton from "../viewDetailButton";
import Card from "./card";
import prettyBytes from "pretty-bytes";

const DataSetCard = ({ dataSet }: { dataSet: any }) => {
  const detailUrl = `/data/sets/${dataSet.public_id}`;
  return (
    <Card className="flex flex-row">
      <div className="flex-grow">
        <Link to={detailUrl} className={"mb-4 text-2xl text-blue-200"}>{dataSet.name}</Link>
        <p className="max-w-fit font-light text-blue-400">
          {dataSet.description}
        </p>
        <div className="mt-4 flex flex-row items-center gap-6">
          <p className="text-sm text-blue-400">
            Data Assets: {dataSet.number_of_assets.toLocaleString()} | Size:{" "}
            {prettyBytes(dataSet.total_data_volume)}
          </p>
          <div className={"grow"} />
          <ViewDetailButton detailUrl={detailUrl} className="mt-0" />
        </div>
      </div>
    </Card>
  );
};

export default DataSetCard;
